import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../hooks/useContent";
import { useSeo } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Section } from "../components/Primitives";
import LeadForm from "../components/LeadForm";
import { Briefcase, Heart } from "lucide-react";

export default function Carrieres() {
  const { t, pick } = useI18n();
  useSeo(t("nav.careers"), "Carrières à la Résidence Doux Instants à Laval : préposé(e)s, infirmier(ère)s, cuisine. Postulez spontanément.");
  const { data: jobs = [] } = useContent("jobs");

  return (
    <>
      <PageHero eyebrow={t("nav.careers")} title="Rejoignez une équipe humaine"
        subtitle="Contribuez à offrir des instants de douceur chaque jour. Postulez dès maintenant."
        image="https://images.pexels.com/photos/6148982/pexels-photo-6148982.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" />

      <Section tone="surface" data-testid="jobs-section">
        <h2 className="font-display text-3xl sm:text-4xl">Postes ouverts</h2>
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {jobs.map((j) => (
            <div key={j.id} className="rounded-2xl border border-black/5 bg-[#F9F6F0] p-6">
              <Briefcase className="h-6 w-6 text-[#2A9D8F]" />
              <h3 className="mt-3 font-display text-xl">{pick(j.title)}</h3>
              <p className="text-sm font-medium text-[#2A9D8F]">{pick(j.type)}</p>
              <p className="mt-2 text-[15px] text-[#5C6370]">{pick(j.desc)}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section tone="sage" data-testid="careers-form-section">
        <div className="flex items-center gap-2">
          <Heart className="h-6 w-6 text-[#2A9D8F]" />
          <h2 className="font-display text-3xl sm:text-4xl">{t("forms.careersTitle")}</h2>
        </div>
        <p className="mt-2 max-w-2xl text-[15px] text-[#5C6370]">
          Le téléversement de CV (PDF/DOCX) sera activé prochainement. En attendant, partagez un lien (LinkedIn/portfolio)
          ou décrivez votre parcours ; notre équipe vous recontactera.
        </p>
        <div className="mt-8 max-w-2xl rounded-3xl border border-black/5 bg-white p-6 sm:p-8">
          <LeadForm kind="careers" />
        </div>
      </Section>
    </>
  );
}
